module.exports = __webpack_public_path__ + "static/media/rim-front-left.0e94cbfb.jpg";